/** @jsx jsx */
import { Flex, FormGroup, FormLabel } from "@eworkit/iris";
import { FormikProps } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";
import * as Yup from "yup";

import { FormikTextInput, VALIDATION_TYPES } from "@/components/Formik";
import { FormikError } from "@/components/Formik";

const NAME_MAX_LENGTH = 50;

export const PROJECT_NAME_ALREADY_EXISTS_ERROR_CODE = "PROJECT_NAME_ALREADY_EXISTS";

export interface TimeReportProjectFormValues {
  name?: string;
}

export const TIME_REPORT_PROJECT_DEFAULT_VALUES: TimeReportProjectFormValues = {
  name: "",
};

export const TIME_REPORT_PROJECT_VALIDATION_SCHEMA = Yup.object().shape({
  name: Yup.string().required(VALIDATION_TYPES.REQUIRED).max(NAME_MAX_LENGTH, VALIDATION_TYPES.MAX_LENGTH),
});

interface TimeReportProjectFormFieldsProps {
  formik: FormikProps<TimeReportProjectFormValues>;
}

export const TimeReportProjectFormFields: FC<TimeReportProjectFormFieldsProps> = ({}) => {
  const { t } = useTranslation(["session", "common"]);

  return (
    <Flex flexDirection="column" gap="sm">
      <FormGroup
        label={<FormLabel required label={t("TIME_REPORTS.PROJECTS.PROJECT_NAME")} />}
        error={
          <FormikError
            name="name"
            overrideMessages={{
              [VALIDATION_TYPES.MAX_LENGTH]: t("common:VALIDATION_MESSAGES.MAX_LENGTH", {
                value: NAME_MAX_LENGTH,
              }),
              [PROJECT_NAME_ALREADY_EXISTS_ERROR_CODE]: t("TIME_REPORTS.PROJECTS.PROJECT_NAME_ALREADY_EXISTS"),
            }}
          />
        }>
        <FormikTextInput name="name" size="lg" />
      </FormGroup>
    </Flex>
  );
};
